import * as Pages from "../pages";

export default [
  // { id: 0, path: "/dao/staking", component: Pages.Stacking },
  { id: 1, path: "/voting", component: Pages.DaoVoiting, exact: true },
  {
    id: 2,
    path: "/dao/product-voting",
    component: Pages.ProductVoiting,
    exact: true,
  },
  { id: 3, path: "/dao/product-voting/:id", component: Pages.ProductOverview },
  // { id: 4, path: "/dao/submission", component: Pages.ProductSubmission },
  // { id: 5, path: "/dao/ddf", component: Pages.Ddf, exact: true },
  // { id: 6, path: "/dao/ddf/active/:id", component: Pages.DdfActiveProposal },
  // {
  //   id: 7,
  //   path: "/dao/ddf/approve/:id",
  //   component: Pages.ApproveProducts,
  //   exact: true,
  // },
  // { id: 8, path: "/dao/admin", component: Pages.Admin, exact: true },
  // { id: 9, path: "/dao/admin/veto/:id", component: Pages.AdminVeto },
  // { id: 10, path: "/dao/admin/submitted/:id", component: Pages.AdminSubmitted },
  { id: 11, path: "/trade", component: Pages.Trade },
  { id: 12, path: "/farm/hr", component: Pages.FarmHR },
  { id: 12, path: "/farm/cohort", component: Pages.FarmCohort },
  { id: 12, path: "/farm/lpt", component: Pages.FarmLPT },
  { id: 13, path: "/swap", component: Pages.Swap },
  { id: 14, path: "/rewards", component: Pages.Rewards },
];
